/**
 * @generated SignedSource<<41920643f43505833b988df4d4bcc7f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FeatureFlagSelectorQuery$variables = {};
export type FeatureFlagSelectorQuery$data = {
  readonly adminListFeatureFlags: ReadonlyArray<{
    readonly enabled: boolean;
    readonly id: string;
    readonly name: string;
  }>;
};
export type FeatureFlagSelectorQuery = {
  response: FeatureFlagSelectorQuery$data;
  variables: FeatureFlagSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminFeatureFlag",
    "kind": "LinkedField",
    "name": "adminListFeatureFlags",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FeatureFlagSelectorQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FeatureFlagSelectorQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "1fd2d9cff1fa218982945e365fe163e8",
    "id": null,
    "metadata": {},
    "name": "FeatureFlagSelectorQuery",
    "operationKind": "query",
    "text": "query FeatureFlagSelectorQuery {\n  adminListFeatureFlags {\n    id\n    name\n    enabled\n  }\n}\n"
  }
};
})();

(node as any).hash = "cb4939d5bd118828eccb079c98d253b1";

export default node;
